export default "__VITE_ASSET__BHfRP4tl__"